export default new google.maps.StyledMapType([
    {
        "stylers": [
            {
                "saturation": 35
            },
            {
                "invert_lightness": true
            },
            {
                "lightness": 5
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "hue": "#303544"
            },
            {
                "saturation": -80
            },
            {
                "invert_lightness": true
            },
            {
                "lightness": -60
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#61afef"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#191a24"
            },
            {
                "saturation": -35
            },
            {
                "lightness": -45
            },
            {
                "visibility": "on"
            },
            {
                "weight": 3
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#767a8c"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#2a2b33"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#35415a"
            },
            {
                "weight": 0.5
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "stylers": [
            {
                "color": "#2a2b33"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2a2b33"
            },
            {
                "saturation": 10
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#767a8c"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#111111"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#151515"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#353741"
            }
        ]
    }
], {
    name: 'Blue'
})